<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 10:11:15
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-08 11:24:50
-->
<template>
  <div>
    <div class="top">
      <el-tabs v-model="activeName" type="card"  @tab-click="handleClick">
         <el-tab-pane label="管理员操作" name="first"></el-tab-pane>
        <el-tab-pane label="管理员登录" name="second"></el-tab-pane>
        <el-tab-pane label="用户登录" name="third"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="search">
      <a-range-picker v-model="time" format="YYYY-MM-DD HH:mm:ss" />
      <a-input
        style="width: 170px; margin-right: 20px;margin-left:20px"
        v-model="content"
        placeholder="操作"
      />
      <a-input
        style="width: 170px; margin-right: 20px"
        v-model="name"
        placeholder="用户"
      />
      <a-input
        style="width: 170px; margin-right: 20px"
        v-model="ip"
        placeholder="IP"
      />
      <el-button @click="search" type="primary">查询</el-button>
    </div>
    <coententTable
      :y="height"
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :pagination="pagination"
      :dataSource="dataSource"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
    ></coententTable>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import { selectListPage } from "./operation_log";
export default {
  data() {
    return {
      height: 0,
      loading: false,
      activeName:"first",
      type: 0,
      columns: [
        {
          title: "操作时间",
          dataIndex: "time",
           width: 200,
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "content",
          width: 120,
          ellipsis: true,
        },
        {
          title: "用户",
          dataIndex: "name",
           width: 120,
          ellipsis: true,
        },
        {
          title: "IP",
          dataIndex: "ip",
           width: 120,
          ellipsis: true,
        },
        {
          title: "请求路径",
          dataIndex: "route",
           width: 400,
          ellipsis: true,
           customCell: column => {
                            return {
                            style: {
                                'min-width': "220px",
                                'max-width': "400px",
                            }
                        };
                        },
                        customHeaderCell: column => {
                        return {
                            style: {
                                'min-width': "220px",
                                'max-width': "400px",
                            }
                        };
                        }
        },
        {
          title: "请求参数",
          dataIndex: "parameter",
          ellipsis: true,
           customCell: column => {
                            return {
                            style: {
                                'min-width': "320px",
                                'max-width': "600px",
                            }
                        };
                        },
                        customHeaderCell: column => {
                        return {
                            style: {
                                'min-width': "320px",
                                'max-width': "600px",
                            }
                        };
                        }
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
      },
      dataSource: [],
      time: undefined,
      content: "",
      name: "",
      ip: "",
      codeData:[],
    };
  },
  components: {
    coententTable,
  },
  mounted() {
    this.getList();
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
     handleClick(){
        if(this.activeName == 'first'){
            this.type = 0;
            this.getList();
        }
         if(this.activeName == 'second'){
            this.type = 1;
            this.getList();
        }
         if(this.activeName == 'third'){
            this.type = 2;
            this.getList();
        }
      },
    search() {
      this.pagination.current = 1;
      this.getList();
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      (":");
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD+ ' ' + hh+mm+ss;
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.current = 1;
      this.getList();
    },
    changeType(type) {
      this.type = type;
      this.pagination.current = 1;
      this.getList();
    },
    getList() {
      let startTime = '';
      let endTime = '';
      if(this.time){
        startTime  = this.farmatDate(new Date(this.time[0].toString()).getTime(),'-')
        endTime = this.farmatDate(new Date(this.time[1].toString()).getTime(),'-')
      }
      this.loading = true;
      selectListPage({
        name: this.name,
        ip: this.ip,
        type: this.type,
        startTime,
        endTime,
        content: this.content,
        current: this.pagination.current,
        size: this.pagination.pageSize,
      }).then((res) => {
        this.dataSource = res.data.records;
        this.pagination.current = res.data.current;
        this.pagination.total = res.data.total;
        if(this.pagination.total > 0){
          this.height = document.documentElement.clientHeight - 429;
          window.onresize = () => {
            return (() => {
              this.height = document.documentElement.clientHeight - 429;
            })();
          };
        }
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  padding: 24px;
  .log-box {
    border-bottom: solid 1px #dcdfe6;
    display: flex;
    color: #000;
    .log {
      padding: 10px 20px;
      border-top: solid 1px #dcdfe6;
      border-left: solid 1px #dcdfe6;
      cursor: pointer;
    }
    .log:last-child {
      border-right: solid 1px #dcdfe6;
      border-top-right-radius: 10px;
    }
    .log:first-child {
      border-top-left-radius: 10px;
    }
  }
}
.search {
  padding: 0 24px;
  /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
}
.el-button--primary {
  background: #176de6;
}
</style>